export const driverName = (d) => `${d.first_name || ""} ${d.last_name || ""}`.trim();

export function medicalStatus(expiry) {
  if (!expiry) return null;
  const today = new Date(new Date().toISOString().slice(0, 10));
  const days = (new Date(expiry) - today) / 86400000;
  if (days < 0) return "expired";
  if (days <= 30) return "expiring";
  return "ok";
}

export const MEDICAL_STYLES = {
  expired: "border-[#FF3B30] text-[#FF3B30] bg-[#FF3B30]/10",
  expiring: "border-[#FFB800] text-[#FFB800] bg-[#FFB800]/10",
  ok: "border-[#10B981]/50 text-[#10B981]",
};
